// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBrandChrome } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| SUPER ADMIN MENU - DASHBOARD ||============================== //

const icons = {
    IconBrandChrome
};

const dashboard: NavItemType = {
    id: 'super-admin-dashboard',
    title: <FormattedMessage id="Dashboard" />,
    icon: icons.IconBrandChrome,
    type: 'group',
    url: '/dashboard'
};

export default dashboard;

